import { useMemo } from "react";
import { CalendarEvent, CalendarEventsByTimePeriod } from "./App";
import { ProjectsList } from "./ProjectsList";
import { useProjectsSortedByTime } from "./useProjectsSortedByTime";

interface ProjectsInPeriodProps {
	events: CalendarEvent[];
}

function ProjectsInPeriod(props: ProjectsInPeriodProps) {
	// TODO: Handle errors!
	const projectsSortedByTime = useProjectsSortedByTime(
		props.events,
		console.error,
	);
	return (
		<ProjectsList
			disableFilter
			ignoreDone
			projectsSortedByTime={projectsSortedByTime}
		/>
	);
}

interface TimePeriodViewProps {
	groupedEvents: CalendarEventsByTimePeriod[];
}

export function TimePeriodView(props: TimePeriodViewProps) {
	const eventsDesc = useMemo(() => {
		const rev = [...props.groupedEvents];
		rev.reverse();
		return rev;
	}, [props.groupedEvents]);

	return (
		<>
			{eventsDesc.map((period) => {
				return (
					<div key={period.periodName} className="pt-4 pb-8">
						<div className="flex justify-between max-w-2xl text-lg">
							<h2 className=" font-extrabold pb-3">
								{period.periodName}
							</h2>
							<span>
								{(period.time / 1000 / 60 / 60).toFixed(2)}{" "}
								hours
							</span>
						</div>
						<ProjectsInPeriod events={period.events} />
					</div>
				);
			})}
		</>
	);
}
